import * as React from "react";
import { classNames } from "../uitk-react-utils/index.js";
import {
  UitkTextThemes,
  UitkTypeAlignments,
  UitkTypeHyphens,
  UitkTypeMargins,
  UitkTypeOverflows,
  UitkTypeSizes,
  UitkTypeWeights,
  UitkTypeWhiteSpaces
} from "./types.js";
export function UitkText({
  align,
  children,
  inline,
  spacing,
  overflow,
  size = 300,
  weight,
  whiteSpace,
  className,
  theme = "default",
  dataTestId,
  hyphens,
  style,
  lineClamp,
  ...attributes
}) {
  let Tag;
  if (inline && typeof inline === "boolean") {
    Tag = "span";
  } else if (inline && typeof inline === "string") {
    Tag = inline;
  } else {
    Tag = "div";
  }
  const wrapperClassNames = classNames(
    "uitk-text",
    align && UitkTypeAlignments.get(align),
    spacing && UitkTypeMargins.get(spacing),
    overflow && !inline && UitkTypeOverflows.get(overflow),
    hyphens && UitkTypeHyphens.get(hyphens),
    size && UitkTypeSizes.get(size),
    weight && UitkTypeWeights.get(weight),
    whiteSpace && UitkTypeWhiteSpaces.get(whiteSpace),
    lineClamp && `uitk-text-line-clamp`,
    className,
    theme && UitkTextThemes.get(theme)
  );
  let tagStyle = style;
  if (style && lineClamp) {
    tagStyle = { ...style, WebkitLineClamp: lineClamp };
  } else if (!style && lineClamp) {
    tagStyle = { WebkitLineClamp: lineClamp };
  }
  return children ? /* @__PURE__ */ React.createElement(
    Tag,
    {
      className: wrapperClassNames,
      ...dataTestId ? { "data-test-id": dataTestId } : {},
      ...attributes,
      style: tagStyle
    },
    children
  ) : /* @__PURE__ */ React.createElement(React.Fragment, null);
}
;
UitkText.displayName = "UitkText";
